import { updateTemplate } from "./Common";

const uploadTemplate = updateTemplate;

export { uploadTemplate };
